import classNames from '../../../../../../_virtual/index.mjs';
import React__default, { forwardRef } from 'react';
import modules_82bdfbfc from './Column.module.css.mjs';

/**
 * Utility for basic column layout. Use custom styling or className for more complex cases.
 */ const Column = /*#__PURE__*/ forwardRef(({ as = 'div', gap, className, style: outerStyle, ...props }, ref)=>{
    const Element = as;
    const style = {
        ...outerStyle
    };
    if (gap != null) {
        style.gap = gap === 1 ? 'var(--st-spacing)' : `var(--st-spacing-${gap})`;
    }
    return /*#__PURE__*/ React__default.createElement(Element, {
        ref: ref,
        className: classNames(className, modules_82bdfbfc.column),
        style: style,
        ...props
    });
});

export { Column as default };
//# sourceMappingURL=Column.mjs.map
